import React from 'react'
import { gtmEvent } from 'lib/gtm'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
import Alert from '@material-ui/lab/Alert'
import StepDescription from '../step-description'
import { useStyles } from './styles'
import ConfirmationNumberOutlinedIcon from '@material-ui/icons/ConfirmationNumberOutlined'
import { DownloadMyPGAsection } from 'components/download-mypga-section'
import CoachCardSm from 'components/coach-card-small'
import BookingTypeCard from './booking-type-card'
import StudentCard from './student-card'

const SummaryLayout = ({
  idOrSlug,
  lessonType,
  lessonTypeId,
  locationId,
  startDateTime,
  student,
  lessonCreditBalanceQuantity,
}) => {
  const { title, category, durationInMinutes, coach, facilities } = lessonType
  const facility = facilities.find(({ id }) => id === locationId)
  const profilePhoto = coach?.coachProfile?.profilePhoto
  const studentName = `${student.firstName} ${student.lastName}`

  const classes = useStyles()
  const bookNewSessionUrl = `/coach/${idOrSlug}/schedule?lessonTypeId=${lessonTypeId}&locationId=${locationId}&lessonCreditBalanceQuantity=${lessonCreditBalanceQuantity}`

  const onBookAnotherSession = () => {
    gtmEvent({
      event: 'formSubmit',
      formCategory: 'book-session',
      formAction: 'clicked-book-another-session-button',
    })
    window.location.href = bookNewSessionUrl
  }

  const onViewCoachOfferings = () => {
    gtmEvent({
      event: 'formSubmit',
      formCategory: 'book-session',
      formAction: 'clicked-view-coachofferings-button',
    })
    window.location.href = window.location.pathname
  }

  return (
    <Container className={classes.root}>
      <Grid container>
        <Grid item md={7} xs={12}>
          <StepDescription
            stepText=""
            title="Thank you!"
            description="Your booking is complete. You will receive a confirmation email shortly."
          />
          <Alert
            severity="info"
            className={classes.warningBox}
            icon={
              <ConfirmationNumberOutlinedIcon
                color="primary"
                fontSize="small"
              />
            }
          >
            <strong>We have applied one of the lessons from your pack.</strong>{' '}
            You have {lessonCreditBalanceQuantity} lessons left.
            <br />
            {/* todo calculate exp date, createdAt parameter is needed */}
            {/* They expire on {lessonPacks[0].expirationDuration} */}
          </Alert>

          <Divider className={classes.dividerStyles} />
          <Typography variant="h5" gutterBottom>
            Details
          </Typography>
          <CoachCardSm
            coach={{
              name: coach?.name,
              coachAvatar: profilePhoto,
              facilityName: facility.name,
            }}
          />
          <BookingTypeCard
            category={category}
            facility={facility}
            title={title}
            startDateTime={startDateTime}
            durationInMinutes={durationInMinutes}
            lessonCreditBalanceQuantity={lessonCreditBalanceQuantity}
          />
          <StudentCard student={student} studentName={studentName} />
          <Divider className={classes.dividerStyles} />
          <Grid container spacing={2}>
            <Grid item md={6} xs={12}>
              <Button
                color="primary"
                variant="outlined"
                size="large"
                fullWidth
                onClick={onViewCoachOfferings}
              >
                VIEW COACH OFFERINGS
              </Button>
            </Grid>
            <Grid item md={6} xs={12}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                fullWidth
                onClick={onBookAnotherSession}
              >
                BOOK ANOTHER SESSION
              </Button>
            </Grid>
          </Grid>
          <DownloadMyPGAsection />
        </Grid>
      </Grid>
    </Container>
  )
}

export default SummaryLayout
